import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { LoggingService } from '../../../../modules/src/lib/core/services/logging.service';
import { BillingManager } from '../managers/billing.manager';
import { OrganizationLicenseStatusEnum } from '../enums/organization-license-status.enum';

@Injectable()
export class HasActivatedLicenseGuard implements CanActivate {
  constructor(
    private readonly authGuard: AuthGuard,
    private readonly router: Router,
    private readonly loggingService: LoggingService,
    private readonly billingManager: BillingManager,
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      // If you are not logged-in, redirect to login
      this.authGuard.canActivate(route, state).subscribe(async isAuthenticated => {
        if (isAuthenticated === false) {
          this.loggingService.debug('[Guard:\'has-activated-license\'] - User is not authenticated, therefore we determine that user doesn\'t have an active license and redirect to /login.');
          return resolve(this.router.parseUrl('/login'));
        }

        const licenseStatus = await this.billingManager.getLicenseStatus();
        if (licenseStatus === OrganizationLicenseStatusEnum.Unlicensed) {
          this.loggingService.debug('[Guard:\'has-activated-license\'] - User has never activated the license');
          return resolve(this.router.parseUrl('/onboarding/subscription/create'));
        }

        return resolve(true);
      });
    });
  }
}
